import { ReviewAttestSection } from './section-status.util';

const VALID_SECTIONS: ReviewAttestSection[] = ['identity', 'contact', 'employmentIncome', 'bank'];

function isReviewAttestSection(value: string): value is ReviewAttestSection {
  return (VALID_SECTIONS as string[]).includes(value);
}

// Parses the `required` query param (a comma-separated list of section names)
// into the subset that are recognised ReviewAttestSection values. Unknown
// tokens are dropped rather than throwing, since this drives a non-critical
// query param, not a form submission.
export function parseRequiredSections(param: string | null): ReviewAttestSection[] {
  if (!param) {
    return [];
  }

  return param
    .split(',')
    .map((token) => token.trim())
    .filter(isReviewAttestSection);
}

export function serializeRequiredSections(sections: ReviewAttestSection[]): string {
  return sections.join(',');
}
